import { LIST_CATEGORY_ID } from 'constants/list';
import { ListNameItemType } from 'hooks/search/useSearchContext';

//

/**
 * convert bid event item result to ListNameItem type used in useSearchContext state for
 * providing available list names in the filter panel
 */
export function transformBidEventItemResultsToListNameItems(
  bidEventItems: ReadonlyArray<any>
): ReadonlyArray<ListNameItemType> {
  if (!Array.isArray(bidEventItems) || !bidEventItems.length) {
    return [];
  }

  return bidEventItems.map((bidEventItem: any) => ({
    key: bidEventItem.itemkey.toString(),
    listCategoryId: LIST_CATEGORY_ID.BID_EVENT_ITEMS_LIST,
    name: bidEventItem.description
  }));
}
